import { executeRequest, JFSRequest } from '@jfs/network'
import { clean, isSuccessResponse } from '../utils'
import { integrationMethods } from '../utils/constants'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

// TODO: update
const getRequestBody = (reqObj: any) => {
  const data = clean(reqObj)
  const getId = (val: string) => {
    return integrationMethods?.find((item) => item.value === val)?.id
  }
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  return {
    entity: {
      initiatingEntityId: REACT_APP_CHANNEL_ID,
    },
    processingEntity: {
      processingEntityId: data?.processingEntityId,
      credentials: data?.credentials,
      endpoint: data?.endpoint,
      integrationMethod: getId(data?.integrationMethod),
      name: data?.name,
    },
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const addProcessingEntityMappingReq = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.addProcessingEntity),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addProcessingEntityMappingReq }
